module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.profile) ? _c('div', {
    staticClass: "profile-data"
  }, [_c('form', {
    staticClass: "form",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.resetForm.apply(null, arguments)
      },
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitForm.apply(null, arguments)
      },
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [_vm._t("default"), _vm._v(" "), ((_vm.$current.profile == 'Pier14' || _vm.$current.profile == 'Gieck') && (_vm.isManager || Object.keys(_vm.hrDocuments).length)) ? _c('fieldset', [_c('legend', [_vm._v("HR Dokumente")]), _vm._v(" "), _c('div', {
    staticClass: "fieldset--inner"
  }, [_vm._l((_vm.hrDocuments), function(documents, key) {
    return _c('div', {
      key: key,
      staticClass: "profile--hr-documents"
    }, _vm._l((documents), function(field, index) {
      return _c('div', {
        key: index,
        staticClass: "row"
      }, [_c('label', {
        attrs: {
          "for": "document"
        }
      }, [_c('span', [_vm._v(_vm._s(_vm.getDocumentGroup(key)))])]), _vm._v(" "), _c('div', {
        staticClass: "form-input"
      }, [(_vm.isUploaded(key)) ? _c('div', {
        staticClass: "form-text"
      }, [_c('a', {
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.downloadFile(key, index)
          }
        }
      }, [_vm._v(_vm._s(field.name))]), _vm._v(" "), (_vm.isManager) ? _c('icon', {
        attrs: {
          "name": "delete"
        },
        nativeOn: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.deleteUpload(key, index)
          }
        }
      }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.getDocumentValue(key)) + ", " + _vm._s(field.date))])], 1) : _vm._e()])])
    }), 0)
  }), _vm._v(" "), (_vm.addDocument) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "dropdown dropdown--framed"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('icon', {
    attrs: {
      "name": "chevron_down",
      "viewBox": "0 0 24 24"
    }
  }), _vm._v("\n                            " + _vm._s(_vm.getDocumentValue(_vm.documentType)) + "\n                            "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.documentType),
      expression: "documentType"
    }],
    attrs: {
      "id": "document_type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.documentType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.documentTypes), function(group) {
    return _c('optgroup', {
      key: group.key,
      attrs: {
        "label": group.label
      }
    }, _vm._l((group.documents), function(doc) {
      return _c('option', {
        domProps: {
          "value": _vm.getDocumentKey(group.key, doc.key)
        }
      }, [_vm._v(_vm._s(doc.label) + "\n                                    ")])
    }), 0)
  }), 0)], 1)])]) : _vm._e(), _vm._v(" "), (_vm.documentType) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-text"
  }, [_c('input', {
    attrs: {
      "id": "document",
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.uploadFile($event, 'document')
      }
    }
  }), _c('br'), _c('br'), _vm._v(" "), _c('small', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancelDocumentUpload()
      }
    }
  }, [_vm._v("abbrechen")])])])]) : _vm._e(), _vm._v(" "), ((_vm.isManager) && !_vm.addDocument) ? _c('div', {
    staticClass: "row"
  }, [_c('br'), _vm._v(" "), (!_vm.addDocument) ? _c('action', {
    attrs: {
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.addDocument = true
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('common.button.add')) + "\n                    ")]) : _vm._e()], 1) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.profile.template), function(fieldset) {
    return (_vm.hasFields(fieldset)) ? _c('fieldset', [_c('legend', [_vm._v(_vm._s(fieldset.name[_vm.$lang]))]), _vm._v(" "), (typeof fieldset.hidden !== 'undefined') ? _c('small', [(fieldset.hidden) ? _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          fieldset.hidden = false
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('text.show_details')))]) : _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          fieldset.hidden = true
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('text.hide_details')))])]) : _vm._e(), _vm._v(" "), (fieldset.note) ? _c('div', {
      staticClass: "note",
      staticStyle: {
        "margin-top": "20px"
      }
    }, [_vm._v(_vm._s(fieldset.note[_vm.$lang]))]) : _vm._e(), _vm._v(" "), _c('div', {
      class: ['fieldset--inner', fieldset.hidden ? 'is-hidden' : null]
    }, _vm._l((fieldset.fields), function(field) {
      return (_vm.showField(field)) ? _c('div', {
        class: _vm.getClasses(field)
      }, [(field.type == 'divider') ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.showLabel(field)) ? _c('label', {
        attrs: {
          "for": field.id
        }
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.label(field))
        }
      }), _vm._v(" "), (field.description) ? _c('icon', {
        directives: [{
          name: "tooltip",
          rawName: "v-tooltip",
          value: (field.description[_vm.$lang]),
          expression: "field.description[$lang]"
        }],
        attrs: {
          "name": "info"
        }
      }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (field.type == 'text') ? _c('div', {
        staticClass: "form-input",
        class: {
          error: _vm.$v.hasError(field.id)
        },
        style: (field.width ? 'width:' + field.width : null)
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.profile.values[field.id]),
          expression: "profile.values[field.id]"
        }],
        attrs: {
          "id": field.id,
          "type": "text",
          "disabled": _vm.isDisabled(field)
        },
        domProps: {
          "value": (_vm.profile.values[field.id])
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.profile.values, field.id, $event.target.value)
          }
        }
      }), _vm._v(" "), _c('error', {
        attrs: {
          "message": _vm.$v.message(field.id)
        }
      })], 1) : _vm._e(), _vm._v(" "), (field.type == 'textarea') ? _c('div', {
        staticClass: "form-input",
        class: {
          error: _vm.$v.hasError(field.id)
        },
        style: (field.width ? 'width:' + field.width : null)
      }, [_c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.profile.values[field.id]),
          expression: "profile.values[field.id]"
        }],
        attrs: {
          "id": field.id,
          "disabled": _vm.isDisabled(field),
          "readonly": _vm.isReadonly(field)
        },
        domProps: {
          "value": (_vm.profile.values[field.id])
        },
        on: {
          "keypress": function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
            $event.stopPropagation();
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.profile.values, field.id, $event.target.value)
          }
        }
      }), _vm._v(" "), _c('error', {
        attrs: {
          "message": _vm.$v.message(field.id)
        }
      })], 1) : _vm._e(), _vm._v(" "), (field.type == 'email') ? _c('div', {
        staticClass: "form-input",
        class: {
          error: _vm.$v.hasError(field.id)
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.profile.values[field.id]),
          expression: "profile.values[field.id]"
        }],
        attrs: {
          "id": field.id,
          "type": "email",
          "disabled": _vm.isDisabled(field)
        },
        domProps: {
          "value": (_vm.profile.values[field.id])
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.profile.values, field.id, $event.target.value)
          }
        }
      }), _vm._v(" "), _c('error', {
        attrs: {
          "message": _vm.$v.message(field.id)
        }
      })], 1) : _vm._e(), _vm._v(" "), (field.type == 'date') ? _c('div', {
        staticClass: "form-input",
        class: {
          error: _vm.$v.hasError(field.id)
        },
        staticStyle: {
          "width": "160px"
        }
      }, [_c('pikaday', {
        attrs: {
          "id": field.id,
          "date": _vm.profile.values[field.id],
          "disabled": _vm.isDisabled(field)
        },
        on: {
          "change": _vm.updateDate
        }
      }), _vm._v(" "), _c('icon', {
        directives: [{
          name: "tooltip",
          rawName: "v-tooltip",
          value: (_vm.$t('tooltip.date_info')),
          expression: "$t('tooltip.date_info')"
        }],
        staticClass: "date-info",
        attrs: {
          "name": "info"
        }
      }), _vm._v(" "), _c('error', {
        attrs: {
          "message": _vm.$v.message(field.id)
        }
      })], 1) : _vm._e(), _vm._v(" "), (field.type == 'number') ? _c('div', {
        staticClass: "form-input",
        class: {
          error: _vm.$v.hasError(field.id)
        },
        style: (field.width ? 'width:' + field.width : null)
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.profile.values[field.id]),
          expression: "profile.values[field.id]"
        }],
        attrs: {
          "id": field.id,
          "type": "number",
          "step": field.step ? field.step : 1,
          "disabled": _vm.isDisabled(field)
        },
        domProps: {
          "value": (_vm.profile.values[field.id])
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.profile.values, field.id, $event.target.value)
          }
        }
      }), _vm._v(" "), (_vm.$current.profile == 'Gieck' && field.id === 'contract_hours' && _vm.profile.values[field.id]) ? _c('div', {
        staticStyle: {
          "margin-top": "5px",
          "font-size": "0.9em",
          "color": "#666"
        }
      }, [_c('div', [_vm._v("Pro Woche: " + _vm._s((_vm.profile.values[field.id] / 52).toFixed(2)))]), _vm._v(" "), _c('div', [_vm._v("Pro Monat: " + _vm._s((_vm.profile.values[field.id] / 12).toFixed(2)))])]) : _vm._e(), _vm._v(" "), _c('error', {
        attrs: {
          "message": _vm.$v.message(field.id)
        }
      })], 1) : _vm._e(), _vm._v(" "), (field.type == 'upload') ? _c('div', {
        staticClass: "form-input",
        class: {
          error: _vm.$v.hasError(field.id)
        }
      }, [(_vm.isUploaded(field.id)) ? _c('div', {
        staticClass: "form-text"
      }, [_c('a', {
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.downloadFile(field.id, 0)
          }
        }
      }, [_vm._v(_vm._s(_vm.uploads[field.id][0].name))]), _vm._v(" "), _c('icon', {
        attrs: {
          "name": "delete"
        },
        nativeOn: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.deleteUpload(field.id, 0)
          }
        }
      })], 1) : _c('input', {
        attrs: {
          "id": field.id,
          "type": "file",
          "disabled": _vm.isDisabled(field)
        },
        on: {
          "change": function($event) {
            return _vm.uploadFile($event, field)
          }
        }
      }), _vm._v(" "), _c('error', {
        attrs: {
          "message": _vm.$v.message(field.id)
        }
      })], 1) : _vm._e(), _vm._v(" "), (field.type == 'multi-upload') ? _c('div', {
        staticClass: "form-input",
        class: {
          error: _vm.$v.hasError(field.id)
        }
      }, [_vm._l((_vm.uploads[field.id]), function(file, index) {
        return _c('div', {
          key: index
        }, [(_vm.isUploaded(field.id)) ? _c('div', {
          staticClass: "form-text"
        }, [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.downloadFile(field.id, index)
            }
          }
        }, [_vm._v(_vm._s(file.name))]), _vm._v(" "), _c('icon', {
          attrs: {
            "name": "delete"
          },
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.deleteUpload(field.id, index)
            }
          }
        }), _vm._v(" "), _c('br')], 1) : _vm._e()])
      }), _vm._v(" "), (_vm.addUpload[field.id] === true || !_vm.uploads[field.id]) ? _c('div', [_c('input', {
        attrs: {
          "id": field.id,
          "type": "file",
          "disabled": _vm.isDisabled(field)
        },
        on: {
          "change": function($event) {
            return _vm.uploadFile($event, field)
          }
        }
      }), _vm._v(" "), _c('error', {
        attrs: {
          "message": _vm.$v.message(field.id)
        }
      })], 1) : _vm._e(), _vm._v(" "), (_vm.uploads[field.id] && (_vm.addUpload[field.id] === false || _vm.addUpload[field.id] === undefined)) ? _c('div', [_c('action', {
        staticClass: "button--small",
        staticStyle: {
          "margin-left": "0"
        },
        attrs: {
          "color": "blue"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.$set(_vm.addUpload, field.id, true)
          }
        }
      }, [_vm._v("+ " + _vm._s(_vm.$t('common.button.add')) + "\n                            ")])], 1) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (field.type == 'checkbox') ? _c('div', {
        staticClass: "form-checkbox",
        class: {
          error: _vm.$v.hasError(field.id)
        }
      }, [_c('label', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.profile.values[field.id]),
          expression: "profile.values[field.id]"
        }],
        attrs: {
          "type": "checkbox",
          "id": field.id,
          "value": "1",
          "disabled": _vm.isDisabled(field)
        },
        domProps: {
          "checked": Array.isArray(_vm.profile.values[field.id]) ? _vm._i(_vm.profile.values[field.id], "1") > -1 : (_vm.profile.values[field.id])
        },
        on: {
          "change": function($event) {
            var $$a = _vm.profile.values[field.id],
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = "1",
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(_vm.profile.values, field.id, $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(_vm.profile.values, field.id, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(_vm.profile.values, field.id, $$c)
            }
          }
        }
      }), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.label(field))
        }
      })]), _vm._v(" "), _c('error', {
        attrs: {
          "message": _vm.$v.message(field.id)
        }
      })], 1) : _vm._e(), _vm._v(" "), (field.type == 'auto') ? _c('div', {
        staticClass: "form-input form-input-tags",
        class: {
          error: _vm.$v.hasError(field.id)
        },
        on: {
          "keypress": function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
            $event.stopPropagation();
          }
        }
      }, [_c('v-select', {
        attrs: {
          "options": _vm.getCollection(field),
          "disabled": _vm.isDisabled(field)
        },
        on: {
          "input": function($event) {
            return _vm.setValue(field)
          }
        },
        model: {
          value: (_vm.selection[field.id]),
          callback: function($$v) {
            _vm.$set(_vm.selection, field.id, $$v)
          },
          expression: "selection[field.id]"
        }
      }, [_c('span', {
        attrs: {
          "slot": "no-options"
        },
        slot: "no-options"
      }, [_vm._v(_vm._s(_vm.$t('text.no_results')))])]), _vm._v(" "), _c('error', {
        attrs: {
          "message": _vm.$v.message(field.id)
        }
      })], 1) : _vm._e(), _vm._v(" "), (field.type == 'radio') ? _c('div', {
        staticClass: "form-radio",
        class: {
          error: _vm.$v.hasError(field.id)
        }
      }, [_vm._l((field.options), function(option, key) {
        return _c('label', [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.profile.values[field.id]),
            expression: "profile.values[field.id]"
          }],
          attrs: {
            "type": "radio",
            "id": field.id + '_' + key,
            "disabled": _vm.isDisabled(field)
          },
          domProps: {
            "value": key,
            "checked": _vm._q(_vm.profile.values[field.id], key)
          },
          on: {
            "change": function($event) {
              return _vm.$set(_vm.profile.values, field.id, key)
            }
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(option))])])
      }), _vm._v(" "), _c('error', {
        attrs: {
          "message": _vm.$v.message(field.id)
        }
      })], 2) : _vm._e(), _vm._v(" "), (field.type == 'yesno') ? _c('div', {
        staticClass: "form-radio",
        class: {
          error: _vm.$v.hasError(field.id)
        }
      }, [_c('label', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.profile.values[field.id]),
          expression: "profile.values[field.id]"
        }],
        attrs: {
          "type": "radio",
          "id": field.id + '_yes',
          "disabled": _vm.isDisabled(field)
        },
        domProps: {
          "value": 1,
          "checked": _vm._q(_vm.profile.values[field.id], 1)
        },
        on: {
          "change": function($event) {
            return _vm.$set(_vm.profile.values, field.id, 1)
          }
        }
      }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('text.yes')))])]), _vm._v(" "), _c('label', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.profile.values[field.id]),
          expression: "profile.values[field.id]"
        }],
        attrs: {
          "type": "radio",
          "id": field.id + '_no',
          "disabled": _vm.isDisabled(field)
        },
        domProps: {
          "value": 0,
          "checked": _vm._q(_vm.profile.values[field.id], 0)
        },
        on: {
          "change": function($event) {
            return _vm.$set(_vm.profile.values, field.id, 0)
          }
        }
      }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('text.no')))])]), _vm._v(" "), _c('error', {
        attrs: {
          "message": _vm.$v.message(field.id)
        }
      })], 1) : _vm._e(), _vm._v(" "), (field.type == 'select') ? _c('div', {
        class: ['dropdown', 'dropdown--framed', _vm.isDisabled(field) ? 'disabled' : '', _vm.$v.hasError(field.id) ? 'error' : '']
      }, [_c('span', {
        staticClass: "label"
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.label(field))
        }
      }), _vm._v(" "), (field.description) ? _c('icon', {
        directives: [{
          name: "tooltip",
          rawName: "v-tooltip",
          value: (field.description[_vm.$lang]),
          expression: "field.description[$lang]"
        }],
        attrs: {
          "name": "info"
        }
      }) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('icon', {
        attrs: {
          "name": "chevron_down",
          "viewBox": "0 0 24 24"
        }
      }), _vm._v("\n                            " + _vm._s(_vm.getSelectedValue(field)) + "\n                            "), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.profile.values[field.id]),
          expression: "profile.values[field.id]"
        }],
        attrs: {
          "id": field.id,
          "disabled": _vm.isDisabled(field)
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(_vm.profile.values, field.id, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.getOptions(field)), function(value, key) {
        return _c('option', {
          domProps: {
            "value": key
          }
        }, [_vm._v(_vm._s(value))])
      }), 0)], 1), _vm._v(" "), _c('error', {
        attrs: {
          "message": _vm.$v.message(field.id)
        }
      })], 1) : _vm._e(), _vm._v(" "), (_vm.$current.profile == 'Ryanair' && field.id == 'health_insurance_law' && _vm.profile.values[field.id] == 'unknown_uninsured' && !_vm.mobile) ? _c('div', {
        staticClass: "note",
        staticStyle: {
          "margin-top": "20px"
        }
      }, [_vm._v(_vm._s(_vm.$t('sko.malta.tk.0')) + " "), _c('a', {
        attrs: {
          "href": "https://www.meinsternum.de/tk-airmalta",
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(_vm.$t('sko.malta.tk.1')))]), _vm._v("\n                        " + _vm._s(_vm.$t('sko.malta.tk.2')) + " "), _c('a', {
        attrs: {
          "href": "/static/Welcome-to-Germany.pdf",
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(_vm.$t('sko.malta.tk.3')))]), _vm._v(".")]) : _vm._e()]) : _vm._e()
    }), 0)]) : _vm._e()
  }), _vm._v(" "), (_vm.$onduro.hasModule('freelancers')) ? _c('fieldset', [_c('legend', [_vm._v("Freelancer")]), _vm._v(" "), _c('div', {
    staticClass: "fieldset--inner"
  }, [(_vm.$onduro.hasRole(['owner', 'manager'])) ? _c('div', {
    staticClass: "row"
  }, [_c('label', {
    attrs: {
      "for": "roles"
    }
  }, [_vm._v(_vm._s(_vm.$t('page.team.user_is')))]), _vm._v(" "), _c('div', {
    staticClass: "form-checkbox"
  }, [(_vm.$onduro.hasModule('freelancers')) ? _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.values['is_freelancer']),
      expression: "profile.values['is_freelancer']"
    }],
    attrs: {
      "type": "checkbox",
      "value": "freelancer"
    },
    domProps: {
      "checked": Array.isArray(_vm.profile.values['is_freelancer']) ? _vm._i(_vm.profile.values['is_freelancer'], "freelancer") > -1 : (_vm.profile.values['is_freelancer'])
    },
    on: {
      "change": function($event) {
        var $$a = _vm.profile.values['is_freelancer'],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "freelancer",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.profile.values, 'is_freelancer', $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.profile.values, 'is_freelancer', $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.profile.values, 'is_freelancer', $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.role.freelancer')))]), _vm._v(" "), _c('div', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.$t('page.team.hint.role_freelancer')))])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('input.freelancer.autoInvoice')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.values['auto_invoice']),
      expression: "profile.values['auto_invoice']"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.profile.values['auto_invoice']) ? _vm._i(_vm.profile.values['auto_invoice'], null) > -1 : (_vm.profile.values['auto_invoice'])
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.profile.values['auto_invoice'],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.profile.values, 'auto_invoice', $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.profile.values, 'auto_invoice', $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.profile.values, 'auto_invoice', $$c)
        }
      }, _vm.updateAutoInvoice]
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.button.yes')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('input.freelancer.shiftVat')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.values['vat_shifted']),
      expression: "profile.values['vat_shifted']"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.profile.values['vat_shifted']) ? _vm._i(_vm.profile.values['vat_shifted'], null) > -1 : (_vm.profile.values['vat_shifted'])
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.profile.values['vat_shifted'],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.profile.values, 'vat_shifted', $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.profile.values, 'vat_shifted', $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.profile.values, 'vat_shifted', $$c)
        }
      }, _vm.updateShiftVat]
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.button.yes')))])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('common.text.businessNumber')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.values['business_number']),
      expression: "profile.values['business_number']"
    }],
    attrs: {
      "type": "text",
      "id": "business_number"
    },
    domProps: {
      "value": (_vm.profile.values['business_number'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile.values, 'business_number', $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('common.text.vatNumber')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.values['vat_number']),
      expression: "profile.values['vat_number']"
    }],
    attrs: {
      "type": "text",
      "id": "vat_number"
    },
    domProps: {
      "value": (_vm.profile.values['vat_number'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile.values, 'vat_number', $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "form-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.values['iban']),
      expression: "profile.values['iban']"
    }],
    attrs: {
      "type": "text",
      "id": "iban",
      "placeholder": "NL12 BANK 1234 5678 90"
    },
    domProps: {
      "value": (_vm.profile.values['iban'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile.values, 'iban', $event.target.value)
      }
    }
  })])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input', {
    staticClass: "btn btn--green btn--profile-save",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.$t('layout.footer.save')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitForm('default')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.$onduro.hasRole(['owner', 'manager', 'accountant'])) ? _c('input', {
    staticClass: "btn btn--orange btn--profile-save",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.$t('layout.footer.saveWithDate')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitForm('date')
      }
    }
  }) : _vm._e()])], 2)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('span', [_vm._v("Dokumenttyp")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "document"
    }
  }, [_c('span', [_vm._v("Dokument")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', [_vm._v("IBAN")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bb5f05d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/Profile.vue
// module id = 564
// module chunks = 234